export const apiURL = process.env.REACT_APP_API_URL;
export const insightsURL = process.env.REACT_APP_INSIGHTS_URL;
export const bChatURL = process.env.REACT_APP_BCHAT_URL;
export const bIntegrationsURL = process.env.REACT_APP_BINTEGRATIONS_URL;
export const encryptionKey = process.env.REACT_APP_ENCRYPTION_KEY;
export const merakiUrl = process.env.REACT_APP_MERAKI_URL;
export const airshipUrl = process.env.REACT_APP_AIRSHIP_URL;
